module.exports = __webpack_public_path__ + "assets/img/tb.afa4b09f.png";